import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { PROCESS } from "../lib/site";

export const Process = () => (
  <section id="proceso" data-testid="process-section" className="relative overflow-hidden bg-glg-surface py-24 sm:py-32">
    <div className="pointer-events-none absolute right-0 top-0 h-80 w-80 rounded-full bg-glg-green/10 blur-[130px]" />
    <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
      <div className="mb-16 max-w-2xl">
        <Reveal><p className="text-xs font-semibold uppercase tracking-[0.3em] text-glg-green">Cómo trabajamos</p></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-4 font-heading text-3xl font-semibold leading-tight tracking-tight text-white sm:text-5xl">
            Del proyecto a la solución
          </h2>
        </Reveal>
      </div>

      <div className="relative">
        {/* connecting line (desktop) */}
        <div className="absolute left-0 right-0 top-6 hidden h-px bg-gradient-to-r from-glg-blue/40 via-white/15 to-glg-blue/40 lg:block" />
        {/* connecting line (mobile vertical) */}
        <div className="absolute bottom-2 left-6 top-2 w-px bg-white/10 lg:hidden" />

        <div className="grid gap-8 lg:grid-cols-5 lg:gap-6">
          {PROCESS.map((step, i) => (
            <motion.div
              key={step.n}
              data-testid={`process-step-${step.n}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative flex gap-4 lg:block"
            >
              <div className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-glg-blue/40 bg-glg-black font-heading text-sm font-bold text-glg-blue">
                {step.n}
              </div>
              <div className="lg:mt-6">
                <h3 className="font-heading text-base font-semibold text-white">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white/50">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
